module.exports = __webpack_public_path__ + "static/img/preview-06.de6f4ea5.webp";